import { onBookkeepingActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { BookkeepingActivityCard } from "./BookkeepingActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  bookkeepingId: number
  config: server.dto.ActivityPanelConfig
}

export const BookkeepingActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.BookkeepingActivity>
    activityKey="bookkeeping"
    itemId={props.bookkeepingId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.Bookkeeping.ListActivity({ itemId: props.bookkeepingId, page, perPage })}
    renderActivity={(activity => <BookkeepingActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onBookkeepingActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
